import {
  MESSAGE_TYPE_TASK,
  MESSAGE_TYPE_FINAL_ANSWER,
  TASK_STATUS_STARTED,
  TASK_STATUS_COMPLETED,
  TASK_STATUS_FINAL,
  TASK_STATUS_FAILED,
  agentType,
} from '../../constants/agentTypes'
import { BubbleChart as BubbleChartIcon } from '@mui/icons-material'
import { get, first, isEmpty } from 'lodash'

export const getTitle = message => {
  if (typeof message.value === 'string' && message.value?.includes('Thought:')) {
    return 'Thought:'
  } else if (typeof message.value === 'string' && message.value?.includes('Observation:')) {
    return 'Observation:'
  } else if (message?.type === MESSAGE_TYPE_TASK && message?.status === TASK_STATUS_STARTED) {
    return 'Adding task'
  } else if (message?.type === MESSAGE_TYPE_TASK && message?.status === TASK_STATUS_COMPLETED) {
    return message.value
  } else if (message?.type === MESSAGE_TYPE_TASK && message?.status === TASK_STATUS_FAILED) {
    return message.value
  } else {
    return null
  }
}

export const getIcon = () => {
  return <BubbleChartIcon />
}

export const getTaskBody = message => {
  if (message.type === MESSAGE_TYPE_TASK && message.status === TASK_STATUS_COMPLETED) {
    return get(message, 'data.output', message.value)
  } else if (message.type === MESSAGE_TYPE_TASK && message.status === TASK_STATUS_FINAL) {
    return get(message, 'data.return_values.output', message.value)
  }
  return message.value
}

const serializeTask = task => {
  const value = first(task.value.split('Action:'), '').replace('Action:', '').replace('Observation:').trim()
  return {
    ...task,
    status: task.status || TASK_STATUS_STARTED,
    value,
  }
}

const serializeCompletedTask = task => {
  const value = first(task.value.split('Action:'), '').replace('Action:', '').replace('Observation:').trim()
  return {
    ...task,
    status: task.status || TASK_STATUS_COMPLETED,
    value,
  }
}

const hasCompletedAnswer = m => {
  return m.data?.log?.includes('Final Answer:') || m.value.includes('Observation:')
}

const isMultiStepAgent = agentTypes => {
  return agentTypes.includes(agentType.planAndExecuteAgent) || agentTypes.includes(agentType.planAndExecuteAgent)
}

const isTorqAGIAgent = agentTypes => {
  return agentTypes.includes(agentType.torqAGI) || agentTypes.includes(agentType.reportAgent)
}

export const getCurrentTasks = (tasks, messages, agentTypes) => {
  // If agent is report agent or plan and execute then set tasks based on status
  if (isMultiStepAgent(agentTypes)) {
    return tasks.filter(task => task.status === TASK_STATUS_STARTED)
  } else if (isTorqAGIAgent(agentTypes)) {
    // has final answer
    const hasCompletedAnswer = !isEmpty(messages.find(m => m.type === MESSAGE_TYPE_FINAL_ANSWER))

    if (hasCompletedAnswer) {
      return []
    }
    // Return tools
    return messages
      .filter(m => m.data?.toolInput)
      .map(m => ({
        ...m,
        status: TASK_STATUS_STARTED,
        value: `Using Tool: ${m.data.tool} with input ${m.data.toolInput}`,
      }))
  } else {
    // TODO: hacky way of getting current tasks, refactor so types are set
    // on backend after refactor of agents
    const hasObservation = !isEmpty(messages.find(m => hasCompletedAnswer(m)))
    // Since other agents can only execute one tasks at a time then clear out previous
    // tasks if observation is present
    if (hasObservation) {
      return []
    }
    return messages.filter(m => m.value.includes('Thought:')).map(t => serializeTask(t))
  }
}

export const getCompletedTasks = (tasks, messages, agentTypes) => {
  if (isMultiStepAgent(agentTypes)) {
    return tasks.filter(task => task.status === TASK_STATUS_COMPLETED)
  } else if (isTorqAGIAgent(agentTypes)) {
    // Return tools
    return messages
      .filter(m => m.type === MESSAGE_TYPE_FINAL_ANSWER)
      .map(m => ({
        ...m,
        status: TASK_STATUS_COMPLETED,
      }))
  } else {
    // TODO: hacky way of getting current tasks, refactor so types are set
    // on backend after refactor of agents
    return messages.filter(m => hasCompletedAnswer(m)).map(t => serializeCompletedTask(t))
  }
}
